import { ReactNode } from "react";
import { Link, useLocation } from "wouter";
import { PageHeader } from "@/components/page-header";
import { cn } from "@/lib/utils";

interface Tab {
  label: string;
  href: string;
  testId: string;
}

const TABS: Tab[] = [
  { label: "Dashboard", href: "/commission/dashboard", testId: "tab-dashboard" },
  { label: "Transactions", href: "/commission/transactions", testId: "tab-transactions" },
  { label: "Import", href: "/commission/import", testId: "tab-import" },
  { label: "Matching", href: "/commission/matching", testId: "tab-matching" },
  { label: "RCTI", href: "/commission/rcti", testId: "tab-rcti" },
];

interface CommissionLayoutProps {
  children: ReactNode;
}

export function CommissionLayout({ children }: CommissionLayoutProps) {
  const [location] = useLocation();

  return (
    <div className="flex h-screen w-full flex-col">
      <PageHeader
        title="Commission Manager"
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Commission Manager" },
        ]}
      />

      <div className="flex-1 overflow-auto bg-muted/20">
        {/* Sub-navigation tabs */}
        <div className="border-b bg-background px-4">
          <nav className="flex gap-0" role="tablist">
            {TABS.map((tab) => {
              const isActive =
                location === tab.href ||
                location.startsWith(tab.href + "?");
              return (
                <Link key={tab.href} href={tab.href}>
                  <button
                    role="tab"
                    data-testid={tab.testId}
                    data-active={isActive ? "true" : "false"}
                    className={cn(
                      "px-4 py-3 text-sm font-medium border-b-2 transition-colors",
                      isActive
                        ? "border-primary text-primary"
                        : "border-transparent text-muted-foreground hover:text-foreground hover:border-muted-foreground"
                    )}
                  >
                    {tab.label}
                  </button>
                </Link>
              );
            })}
          </nav>
        </div>

        {/* Page content */}
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
